import { api } from '@/api'
import { endpoints } from '@/api/endpoints'
import {
  GetTransactionsParams,
  GetTransactionsResponse,
  ApiTransaction,
} from './transactionTypes'

/**
 * Get transactions list with pagination and filters (adapted from RN)
 */
async function getTransactions(
  params: GetTransactionsParams = {},
): Promise<GetTransactionsResponse> {
  const queryParams = new URLSearchParams()

  if (params.page_id !== undefined)
    queryParams.append('page_id', params.page_id.toString())
  if (params.page_size)
    queryParams.append('page_size', params.page_size.toString())
  if (params.search) queryParams.append('search', params.search)
  if (params.from_date)
    queryParams.append('from_date', params.from_date.toString())
  if (params.to_date) queryParams.append('to_date', params.to_date.toString())
  if (params.participant_id)
    queryParams.append('participant_id', params.participant_id)
  if (params.restrict_to_participants)
    queryParams.append(
      'restrict_to_participants',
      params.restrict_to_participants.toString(),
    )

  // Handle arrays like in RN version with arrayFormat: "repeat"
  if (params.currencies?.length) {
    params.currencies.forEach((currency) =>
      queryParams.append('currencies', currency),
    )
  }
  if (params.types?.length) {
    params.types.forEach((type) => queryParams.append('types', type))
  }

  const url = `${endpoints.transfer.transactions}?${queryParams.toString()}`

  const response = await api.get<GetTransactionsResponse>(url)

  return response.data
}

/**
 * Get single transaction by ID
 */
async function getTransactionById(
  transactionId: string,
): Promise<ApiTransaction> {
  const response = await api.get<ApiTransaction>(
    endpoints.transfer.transactionById(transactionId),
  )

  return response.data
}

export const transactionApi = {
  getTransactions,
  getTransactionById,
}
